import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["emailInput"];

  subscribeAnother(e) {
    const form = e.target.closest('form')

    form.querySelector('button').innerHTML = "Subscribe";
    form.querySelector('.email-input').style.display = "block";
    form.querySelector('.another').style.display = "none";
    form.querySelector('input[type="email"]').value = "";
  }

  submitForm(e) {
    e.preventDefault();
    const email = this.emailInputTarget.value;
    const form = e.target.closest('form')

    if (form.reportValidity()) {
      $.ajax({
        url: "/promo_emails",
        type: "POST",
        headers: {
          "X-CSRF-Token": csrfToken()
        },
        data: {
          email: email
        },
        success: (response) => {
          form.querySelector('button').innerHTML = "Subscribed ✓";
          form.querySelector('.email-input').style.display = "none";
          form.querySelector('.another').style.display = "block";
        }
      });
    }
  }
}

